import { render, staticRenderFns } from "./ProductsSliderSkeleton.vue?vue&type=template&id=14b6a269&scoped=true&"
import script from "./ProductsSliderSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductsSliderSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSliderSkeleton.vue?vue&type=style&index=0&id=14b6a269&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b6a269",
  null
  
)

export default component.exports